import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './homologacao.css';

// HOMOLOGACAO DO CHAT (22/10/2026, pedido do Suporte, so' nesta fase de testes): o atendente escolhe uma empresa
// cliente e o chat do cliente (o widget do projeto atendimento-geogrid, carregado do servico do chat desde 04/11/2026)
// aparece no canto de baixo do Suporte como se ele fosse aquela empresa. Ele pergunta como cliente e responde pelo Atendimento (ou outro atendente
// assume). O token de cliente e o Ibex de teste vem do AtendimentoController (/atendimento/homologacao/*); as conversas
// ficam com a origem "homologacao" no servico do chat. A empresa escolhida fica neste navegador ate' "Encerrar teste".

const CHAVE = 'homologacaoChat';
const WIDGET = 'https://atendimento.sistemaggm.net.br/api/widget/';

const SITUACAO = { cliente: 'Cliente', demo: 'Demonstração', parceiro: 'Parceiro', bloqueado: 'Bloqueado' };

export function empresaEmTeste(){
    try{
        return JSON.parse(localStorage.getItem(CHAVE) || 'null');
    }catch(e){
        return null;
    }
}

// trocar de empresa recarrega a pagina: o chat do cliente e' um so' por pagina
function testar(empresa){
    try{
        if(empresa){
            localStorage.setItem(CHAVE, JSON.stringify(empresa));
        }else{
            localStorage.removeItem(CHAVE);
        }
    }catch(e){
        // sem armazenamento: nao da' para lembrar a escolha
    }
    window.location.assign('/painel/atendimento');
}

function carregar(tag, atributos){
    return new Promise((resolve, reject) => {
        const el = document.createElement(tag);
        Object.assign(el, atributos, { onload: resolve, onerror: reject });
        document.head.appendChild(el);
    });
}

let carregado = null;

// o widget do cliente (o mesmo que os sistemas integram, como o Jivo), com o token e o Ibex de teste do Suporte
function carregarChat(empresa, usuario){

    if(carregado){
        return carregado;
    }

    carregado = carregar('script', { src: `${WIDGET}chat.js?v=${Date.now()}` }).then(() => {
        window.GeoGridChat.iniciar({
            usuario: { nome: usuario.nome, email: usuario.email || '', codigoEmpresa: empresa.codigo, empresa: empresa.nome },
            token: async () => (await axios.get('/atendimento/homologacao/token', { params: { empresa: empresa.id } })).data,
            ibex: async corpo => (await axios.post('/atendimento/homologacao/ibex', corpo)).data
        });
    });

    return carregado;
}

// botao no canto de baixo (como o do Ibex na Osorno): abre o chat do cliente; some com o chat aberto
export function ChatHomologacao({ usuario }){

    const empresa = empresaEmTeste();
    const [ pronto, setPronto ] = useState(false);
    const [ erro, setErro ] = useState('');
    const [ aberto, setAberto ] = useState(false);
    const [ naoLidas, setNaoLidas ] = useState(0);

    useEffect(() => {
        if(!empresa){
            return;
        }
        carregarChat(empresa, usuario)
            .then(() => {
                window.GeoGridChat.aoMudar(setAberto);
                window.GeoGridChat.aoNaoLidas(quantidade => setNaoLidas(quantidade));
                setPronto(true);
            })
            .catch(() => setErro('Não foi possível carregar o chat do cliente.'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ESPACO RESERVADO (22/10/2026, pedido do Eden): o chat do cliente nao fica por cima do campo do Atendimento. A pagina
    // deixa uma faixa livre a' direita: estreita com o chat fechado (o botao) e da largura do chat com ele aberto
    const ativo = Boolean(empresa);
    useEffect(() => {
        document.body.classList.toggle('homologacao-chat-ativo', ativo);
        document.body.classList.toggle('homologacao-chat-aberto', ativo && aberto);
    }, [ativo, aberto]);

    if(!empresa || aberto){
        return null;
    }

    return (
        <div className="homologacao-chat-canto">
            <div className="homologacao-chat-quem">
                <span>{erro || `Testando como ${empresa.codigo} · ${empresa.nome}`}</span>
                <button type="button" title="Encerrar o teste" aria-label="Encerrar o teste" onClick={() => testar(null)}>×</button>
            </div>
            <button
                type="button"
                className="homologacao-chat-botao"
                disabled={!pronto}
                title="Abrir o chat como o cliente"
                onClick={() => window.GeoGridChat.abrir()}
            >
                <img src={`${WIDGET}ibex.jpg`} alt="" />
                {naoLidas > 0 && <span className="homologacao-chat-contador">{naoLidas}</span>}
            </button>
        </div>
    );
}

// tela /painel/atendimento/homologar: escolher a empresa para simular
export default function HomologarChat(){

    const atual = empresaEmTeste();
    const [ busca, setBusca ] = useState('');
    const [ empresas, setEmpresas ] = useState(null);
    const [ erro, setErro ] = useState('');

    useEffect(() => {
        let ativo = true;
        const espera = setTimeout(() => {
            axios.get('/atendimento/homologacao/empresas', { params: { busca } })
                .then(({ data }) => {
                    if(!ativo) return;
                    if(data && data.status){
                        setEmpresas(data.empresas);
                        setErro('');
                    }else{
                        setErro((data && data.mensagem) || 'Não foi possível carregar as empresas.');
                    }
                })
                .catch(() => ativo && setErro('Não foi possível carregar as empresas.'));
        }, 300);
        return () => {
            ativo = false;
            clearTimeout(espera);
        };
    }, [busca]);

    return (
        <div className="homologacao-pagina">

            <div className="homologacao-topo">
                <div>
                    <h1>Homologar chat</h1>
                    <p>
                        Escolha a empresa que você quer simular. O chat do cliente aparece no canto de baixo, à direita: você
                        pergunta como o cliente e responde pelo Atendimento (ou outro atendente assume). As conversas ficam
                        marcadas como <strong>Homologação (teste)</strong>.
                    </p>
                </div>
                <button type="button" className="btn btn-outline-secondary" onClick={() => window.history.back()}>Voltar</button>
            </div>

            {atual && (
                <div className="homologacao-atual">
                    <span>Testando agora como <strong>{`${atual.codigo} · ${atual.nome}`}</strong></span>
                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => testar(null)}>Encerrar teste</button>
                </div>
            )}

            <input
                type="search"
                className="form-control homologacao-busca"
                placeholder="Buscar empresa: código, nome ou cidade"
                value={busca}
                onChange={evento => setBusca(evento.target.value)}
                autoFocus
            />

            {erro && <p className="homologacao-vazio">{erro}</p>}
            {!erro && empresas === null && <p className="homologacao-vazio">Carregando...</p>}
            {!erro && empresas && empresas.length === 0 && <p className="homologacao-vazio">Nenhuma empresa com essa busca.</p>}

            {!erro && empresas && empresas.length > 0 && (
                <div className="homologacao-lista">
                    {empresas.map(empresa => (
                        <div key={empresa.id} className={atual && atual.id === empresa.id ? 'homologacao-empresa atual' : 'homologacao-empresa'}>
                            <span className="homologacao-codigo">{empresa.codigo}</span>
                            <span className="homologacao-nome">
                                <strong>{empresa.nome}</strong>
                                <small>{[empresa.cidade, SITUACAO[empresa.situacao] || empresa.situacao].filter(Boolean).join(' · ')}</small>
                            </span>
                            <button type="button" className="btn btn-sm btn-primary" onClick={() => testar(empresa)}>
                                {atual && atual.id === empresa.id ? 'Testando' : 'Simular'}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
